var map = {
	"./amazon.png": "b2e6",
	"./discord.png": "88ab6",
	"./email.png": "4992",
	"./facebook.png": "8fef",
	"./instagram.png": "dd1c",
	"./kwai.png": "3dab",
	"./linkedin.png": "9446",
	"./paypal.png": "693c7",
	"./pinterest.png": "0baa",
	"./reddit.png": "b2ae",
	"./skype.png": "201d",
	"./snapchat.png": "9ae5",
	"./spotify.png": "ad4a",
	"./telegram.png": "0584",
	"./threads.png": "047b",
	"./tiktok.png": "8445",
	"./tinder.png": "d9b0",
	"./twitch.png": "a91f",
	"./web.png": "b6d1",
	"./whatsapp.png": "94a9",
	"./x.png": "af15",
	"./youtube.png": "18bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "693c";